import React from "react"

import Container from "../components/Container"
import Tagline from "../components/Tagline"
import SocialBar from "../components/SocialBar"
import SocialBtn from "../components/SocialBar/SocialBtn"
import myPhoto from "../assets/main-photo.jpg"
import DownloadBtn from "../components/DownloadBtn"
import ContactButton from "../components/ContactButton"

export default function Home() {
    return (
        <Container>
            <article id="home" className="wrapper">
                <section>
                    <h1>Hi,</h1>
                    <h1> I'm Vincent Le.</h1>
                    <div className="title-container">
                        <p className="title">Software Engineer</p>
                        <p className="title">(Data Engineering | Cyber Security | AI | IoT)</p>
                    </div>
                </section>

                <Tagline />

                <section>
                    <DownloadBtn />
                    <ContactButton />
                </section>

                <section>
                    <SocialBar />
                    <div className="cw-badge">
                        <SocialBtn name="cw" href="https://www.codewars.com/users/VincentLeV" />
                        <a href="https://www.codewars.com/users/VincentLeV" target="_blank" rel="noreferrer">
                            <img
                                src="https://www.codewars.com/users/VincentLeV/badges/micro"
                                alt="Codewars Badge"
                            />
                            {/* <p>hidden</p> */}
                        </a>
                    </div>
                </section>

                <img src={myPhoto} alt="My Img" width="360px" className="my-photo" />
            </article>
        </Container>
    )
}
